import getters from '@/store/modules/getters'
import mutations from '@/store/modules/mutations'
import client from '@/base/api/client'
import SysUtils from '@/base/utils/SysUtils'

mutations.COMMENTS = function (state, payload) {
  state.commentsList = payload
}
mutations.PP = function (state, payload) {
  state.post = payload
}

const state = {
  rows: [],
  commentsList: [],
  row: null,
  post: {}
}
const actions = {
  init: ({ commit, state }) => {
    const ctx = {
      data: {
        init: { api: 'M0104SNSPostCommentsService.searchPostCommentList' }
      }
    }
    return client.postData(ctx)
      .then((data) => {
        commit('FIND_ALL', data.init.output)
      })
  },
  getPostAndComment: ({ commit, state }, condition) => {
    return client.postData({ data: {
      post: { api: 'M0102SNSPostMasterService.searchPost', input: condition },
      comments: { api: 'M0104SNSPostCommentsService.searchPostCommentList', input: condition } } })
      .then((data) => {
        if (SysUtils.isEmpty(data.post.output)) {
          commit('PP', {})
        } else {
          commit('PP', data.post.output[0])
        }
        commit('COMMENTS', data.comments.output)
      })
  },
  sendComment: ({ commit, state }, condition) => {
    return client.postData({
      data: {
        send: {
          api: 'M0104SNSPostCommentsService.replyComment',
          input: condition
        }
      }
    }).then((data) => {
      commit('COMMENTS', data.send.output)
    })
  },
  markAsRead: ({ commit, state }, id) => {
    return client.postData({
      data: {
        mark: {
          api: 'M0104SNSPostCommentsService.markAsRead',
          input: {
            id: id
          }
        }
      }
    }).then(() => {
    })
  },
  getCommentList: ({ commit, state }, condition) => {
    return client.postData({
      data: { comments: { api: 'M0104SNSPostCommentsService.searchPostCommentList', input: condition } }
    }).then((data) => {
      commit('FIND_ALL', data.comments.output)
    })
  }
}

const module = {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}

export default module
